/**
 * TeeinBlue Custom Scripts
 * Handles cart drawer updates after TeeinBlue product customization
 */

// Handle cart updates after TeeinBlue product is added
document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }
});

/**
 * Remove USD currency code from cart totals
 * Uses MutationObserver instead of setInterval for better performance
 */
function removeUSDFromTotals() {
  const selectors = [".totals__subtotal-value", ".totals__total-value"];
  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.textContent.includes("USD")) {
        element.textContent = element.textContent.replace(/\s*USD/g, "").trim();
      }
    });
  });
}

// Run once on page load
removeUSDFromTotals();

// Use MutationObserver to watch for cart drawer changes
const cartDrawer = document.querySelector("cart-drawer");
if (cartDrawer) {
  const observer = new MutationObserver((mutations) => {
    // Only process if there were actual changes
    let shouldProcess = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0 || mutation.type === "characterData") {
        shouldProcess = true;
        break;
      }
    }
    if (shouldProcess) {
      removeUSDFromTotals();
    }
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

// Also observe the main cart page if present
const mainCart = document.querySelector("#main-cart-items, #MainContent");
if (mainCart) {
  const cartObserver = new MutationObserver(() => {
    removeUSDFromTotals();
  });

  cartObserver.observe(mainCart, {
    childList: true,
    subtree: true,
  });
}
